import api from "..";

{/* Personal drive APIs */ }

export const fetchPersonalDrives = (params = {}, callBack) => {
    api.get(`/drives/personal/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const fetchSinglePersonalDrive = (id, params = {}, callBack) => {
    api.get(`/drives/${id}/personal/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const createFolder = (data, callBack) => {
    api.post(`/folders/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const renameFolder = (id, data, callBack) => {
    api.patch(`/folders/${id}/rename/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const deleteFolder = (id, callBack) => {
    api.delete(`/folders/${id}/`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const createFile = (data, callBack) => {
    api.post(`/sheets/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const renameFile = (id, data, callBack) => {
    api.put(`/sheets/${id}/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const deleteFile = (id, callBack) => {
    api.delete(`/sheets/${id}/`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const duplicateFolder = (id, callBack) => {
    api.post(`/folders/${id}/duplicate/`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const downloadFolder = (id, callBack) => {
    api.post(`/folders/${id}/download/`, {}, { responseType: 'blob' })
        .then((response) => {
            // Get filename from response headers if available
            const contentDisposition = response.headers['content-disposition'];
            let filename = `folder_${id}.zip`;
            
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            
            // Clean up
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            callBack({ status: true, message: "Folder downloaded successfully" });
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const copyFolder = (id, data, callBack) => {
    api.post(`/folders/${id}/copy/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};




{/* Team drive APIs */ }


export const fetchTeams = (params = {}, callBack) => {
    api.get(`/drives/get-teams/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const fetchSingleTeamDrive = (params = {}, callBack) => {
    api.get(`/drives/team-member/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const fetchSingleTeamSingleDrive = (id, params = {}, callBack) => {
    api.get(`/drives/${id}/team-member/`, { params })
        .then((response) => {
            console.log(response, "respnse");
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};



